import { merge, pick, omitBy, isNil, uniqBy } from 'lodash'
import WebStorageService from '@/modules/_services/webstorage.service'
import { countQuickFilter } from '@/redux/ducks/_helpers'

import invoiceConfig from '@/modules/invoice/config'
import documentConfig from '@/modules/document/config'
import orderConfig from '@/modules/order/config'
import purchaseConfig from '@/modules/purchase/config'
import { getPurchasePartialDeliveryDrawerColumns } from '@/modules/purchase/config/partial-delivery-drawer-list-config'
import deliveryNoteConfig from '@/modules/deliveryNote/config'
import letterConfig from '@/modules/transactionLetter/config'
import bankingConfig, { internalTransferColumns } from '@/modules/banking/config'
import expenseConfig from '@/modules/expense/config'
import revenueConfig from '@/modules/revenue/config'
import projectConfig from '@/modules/project/config'
import miteConfig from '@/modules/apps/own/mite/config'
import recurringinvoiceConfig from '@/modules/recurringInvoice/config'
import customerConfig from '@/modules/customer/config'
import bookingSelectionConfig from '@/modules/base/components/booking-selection-list/config'
import timeTrackingConfig from '@/modules/timetracking/config'
import timeTrackingBillingConfig from '@/modules/timetracking/components/billing/list-config'
import offerConfig from '@/modules/offer/config'
import articleConfig from '@/modules/article/config'
import economicAssetConfig from '@/modules/economicAsset/config'
import debitTransactionConfig from '@/modules/banking/components/direct-debit-transactions/config'
import articleSuppliersAssignDrawerConfig from '@/modules/article/components/edit/stock-management/article-suppliers-assign-drawer-config'
import customerIssuesListConfig from '@/modules/customer-issues/customer-issues-list-config'
import { ACTION_PREFIX_LISTS as actionPrefix } from '@/redux/ducks/constants'
import { printSelection } from './helpers'
import clientListConfig from '@/modules/client/config'
import { getDateFilterItems, handleDateFilters, applyDateFiltersToItems, DATE_FILTER_MODEL_KEY, getDateFilterModel } from '@/modules/banking/_helpers/dateFilters'
import { restoreDateFilterState } from '@/modules/banking/_helpers/periodFilters'
import globalConfig from '@/config'
import request from '@/modules/base/util/request'

// actions setting

const PAGINATION_UPDATE = `${actionPrefix}PAGINATION_UPDATE`
const SEARCH_UPDATE = `${actionPrefix}SEARCH_UPDATE`
const SHALL_EXPORT = `${actionPrefix}SHALL_EXPORT`
const SHALL_REFRESH = `${actionPrefix}SHALL_REFRESH`
const SHALL_SOFT_REFRESH = `${actionPrefix}SHALL_SOFT_REFRESH`
const QUICK_FILTER_INIT = `${actionPrefix}QUICK_FILTER_INIT`
const QUICK_FILTER_UPDATE = `${actionPrefix}QUICK_FILTER_UPDATE`
const QUICK_COUNTER_UPDATE = `${actionPrefix}QUICK_COUNTER_UPDATE`
const FILTER_MODEL_UPDATE = `${actionPrefix}FILTER_MODEL_UPDATE`
const FILTER_ITEMS_UPDATE = `${actionPrefix}FILTER_ITEMS_UPDATE`
const DATE_FILTERS_UPDATE = `${actionPrefix}DATE_FILTERS_UPDATE`
const DATE_FILTERS_CLEAR = `${actionPrefix}DATE_FILTERS_CLEAR`
const SELECTED_NODES_UPDATE = `${actionPrefix}SELECTED_NODES_UPDATE`
const UPDATE_ITEMS = `${actionPrefix}UPDATE_ITEMS`
const UPDATE_DATA = `${actionPrefix}UPDATE_DATA`
const LIST_CLEAR = `${actionPrefix}LIST_CLEAR`
const LIST_ERROR = `${actionPrefix}LIST_ERROR`
const LIST_LOADING = `${actionPrefix}LIST_LOADING`
const LIST_SYNCING = `${actionPrefix}LIST_SYNCING`
const SETTING_UPDATE = `${actionPrefix}SETTING_UPDATE`
const SETTING_ERROR = `${actionPrefix}SETTING_ERROR`
const SETTING_LOADING = `${actionPrefix}SETTING_LOADING`
const SETTING_LOADING_FINISHED = `${actionPrefix}SETTING_LOADING_FINISHED`
const SETTING_MODAL_TOGGLE = `${actionPrefix}SETTING_MODAL_TOGGLE`
const ADD_ITEM = `${actionPrefix}ADD_ITEM`
const START_PRINTING = `${actionPrefix}START_PRINTING`
const STOP_PRINTING = `${actionPrefix}STOP_PRINTING`
const LOCAL_STORE_ENTRY = `${actionPrefix}SETTINGS`
const DELETE_ITEM = `${actionPrefix}DELETE_ITEM`
const UPDATE_CUSTOM_PARAMS = `${actionPrefix}UPDATE_CUSTOM_PARAMS`
const UPDATE_LAST_SELECTED_ROW_INDEX = `${actionPrefix}UPDATE_LAST_SELECTED_ROW_INDEX`
const UPDATE_LAST_EXPANDED_ROW_KEY = `${actionPrefix}UPDATE_LAST_EXPANDED_ROW_KEY`
const UPDATE_AUTO_SIZE_COLUMNS = `${actionPrefix}UPDATE_AUTO_SIZE_COLUMNS`

export const LIST_TYPES = {
  ARTICLE_LIST_TYPE: 'article',
  ARTICLE_REPORT_LIST_TYPE: 'articleReport',
  BANK_ACCOUNT_LIST_TYPE: 'bankAccount',
  BANKING_LIST_TYPE: 'banking',
  BOOKING_ASSIGNMENT_LIST_TYPE: 'bookingAssignment',
  BOOKING_LIST_TYPE: 'booking',
  BOOKING_SELECTION_LIST_TYPE: 'bookingSelection',
  CUSTOMER_LIST_TYPE: 'customer',
  DELIVERY_NOTE_LIST_TYPE: 'deliveryNote',
  EXPENSE_LIST_TYPE: 'expense',
  INTERNAL_BANK_TRANSFER_SELECTION_LIST_TYPE: 'internalBankTransferSelection',
  INVOICE_LIST_TYPE: 'invoice',
  OFFER_LIST_TYPE: 'offer',
  ORDER_LIST_TYPE: 'order',
  PROJECT_LIST_TYPE: 'project',
  RECURRING_INVOICE_LIST_TYPE: 'recurringInvoice',
  REVENUE_LIST_TYPE: 'revenue',
  REVENUE_SELECTION_LIST_TYPE: 'revenueSelection',
  SUPPLIER_LIST_TYPE: 'supplier',
  TIME_TRACKING_BILLING_LIST_TYPE: 'timeTrackingBilling',
  TIME_TRACKING_LIST_TYPE: 'timeTracking',
  TRACKING_LIST_TYPE: 'tracking',
  TURNOVER_LIST_TYPE: 'turnover',
  USER_LIST_TYPE: 'user',
  TODO_LIST_TYPE: 'todo',
  CUSTOM_FIELD_LIST_TYPE: 'customField',
  CLIENT_LIST_TYPE: 'clients',
  DOCUMENTS_LIST_TYPE: 'documents',
  ECONOMIC_ASSET_LIST_TYPE: 'economicAsset',
  LETTER_LIST_TYPE: 'letter',
  PURCHASE_LIST_TYPE: 'purchase',
  PURCHASE_PARTIAL_DELIVERY_DRAWER_LIST_TYPE: 'purchasePartialDeliveryDrawer',
  MANDATE_LIST_TYPE: 'mandateList',
  DEBIT_TRANSACTION_PLANNED_LIST_TYPE: 'directDebitPlannedTransaction',
  DEBIT_TRANSACTION_SETTLED_LIST_TYPE: 'directDebitSettledTransaction',
  IMPORT_POSITIONS_TRANSACTION_PICKER_TYPE: 'importPositionsTransactionPicker',
  IMPORT_POSITIONS_POSITION_PREVIEW_TYPE: 'importPositionsPositionPreview',
  ADD_MULTIPLE_ARTICLES_LIST_TYPE: 'addMultipleArticlesList',
  ARTICLE_SUPPLIERS_ASSIGN_DRAWER_TYPE: 'articleSuppliersAssignDrawer',
  CUSTOMER_ISSUES_LIST_TYPE: 'customerIssues',
}

const defaultSettings = {
  pagination: {
    offset: 0, // current starting point in list
    count: 0, // count of filtered items
    limit: 20, // max items on page
  },
  meta: {
    count: 0,
    totalCount: 0,
  },
  searchTerm: '',
  customParams: {},
  fetchCounters: true,
  filter: 'all',
  filterModel: null,
  filterItems: [],
  dateFilters: [],
  dateFilterItems: [],
  quickFilter: null,
  selectedNodes: [],
  lastSelectedRowIndex: null,
  /*
    Key of the row whose children were open when the user left the list, so it can be opened again on
    the way back. Must survive SHALL_REFRESH: entering a list purges the grid, and it is exactly that
    purge which gives ag-grid the chance to open the row again.
  */
  lastExpandedRowKey: null,
  items: [],
  error: null,
  isFirstUpdate: true,
  isLoading: false,
  isSyncing: false,
  isSettingLoading: false,
  settingModalOpen: false,
  setting: {
    autoSizeColumns: true,
    columns: [],
  },
  settingError: null,
  shallExport: false,
  shallRefresh: false,
  shallSoftRefresh: false,
  exportItems: [],
  printing: false,
}

export const PERIOD_FILTER_LISTS = [LIST_TYPES.EXPENSE_LIST_TYPE, LIST_TYPES.REVENUE_LIST_TYPE]

const saveToLocalStorage = (listName, state) => {
  try {
    const keys = ['pagination.limit', 'filterModel', 'filter', 'quickFilter']
    const toSave = pick(state[listName], PERIOD_FILTER_LISTS.includes(listName) ? [...keys, 'dateFilters'] : keys)
    WebStorageService.setItem(`${LOCAL_STORE_ENTRY}/${listName.toUpperCase()}`, toSave)
  } catch {
  }
}

export const loadFromLocalStorage = (listName) => {
  try {
    const serializedState = WebStorageService.getItem(`${LOCAL_STORE_ENTRY}/${listName.toUpperCase()}`)
    if (serializedState === null) return { ...defaultSettings }
    return merge({}, defaultSettings, serializedState)
  } catch {
    return { ...defaultSettings }
  }
}

const loadPeriodFilterList = (listName, extra) => {
  const saved = loadFromLocalStorage(listName)
  return { ...merge({}, defaultSettings, saved, extra), ...restoreDateFilterState(saved.dateFilters) }
}

export const getListSettingNameInBackend = (listName) => {
  switch (listName) {
    case LIST_TYPES.TIME_TRACKING_LIST_TYPE:
      return 'trackedTime'
    case LIST_TYPES.CLIENT_LIST_TYPE:
      return 'client'
    default:
      return listName
  }
}

// methods fo dynamic quick filter creation
const getFilterItems = {
  [LIST_TYPES.BOOKING_SELECTION_LIST_TYPE]: bookingSelectionConfig.getFilterItems,
  [LIST_TYPES.REVENUE_SELECTION_LIST_TYPE]: bookingSelectionConfig.getFilterItems,
}

// reducer
const initialState = {
  [LIST_TYPES.BANKING_LIST_TYPE]: merge(
    {},
    defaultSettings,
    loadFromLocalStorage(LIST_TYPES.BANKING_LIST_TYPE),
    {
      filterItems: bankingConfig.filters,
      dateFilterItems: getDateFilterItems(undefined),
    }),
  [LIST_TYPES.BOOKING_LIST_TYPE]: merge(
    {},
    defaultSettings,
    loadFromLocalStorage(LIST_TYPES.BOOKING_LIST_TYPE),
    {
      filterItems: bankingConfig.filters,
      dateFilterItems: getDateFilterItems(undefined),
    }),
  [LIST_TYPES.EXPENSE_LIST_TYPE]: loadPeriodFilterList(LIST_TYPES.EXPENSE_LIST_TYPE, { filterItems: expenseConfig.filters }),
  [LIST_TYPES.INVOICE_LIST_TYPE]: merge({}, defaultSettings, loadFromLocalStorage(LIST_TYPES.INVOICE_LIST_TYPE), { filterItems: invoiceConfig.filters }),
  [LIST_TYPES.REVENUE_LIST_TYPE]: loadPeriodFilterList(LIST_TYPES.REVENUE_LIST_TYPE, { filterItems: revenueConfig.filters }),
  [LIST_TYPES.TRACKING_LIST_TYPE]: merge({}, defaultSettings, loadFromLocalStorage(LIST_TYPES.TRACKING_LIST_TYPE),
    {
      filterItems: miteConfig.filters,
      setting: {
        columns: miteConfig.columns,
      },
    }),
  [LIST_TYPES.DELIVERY_NOTE_LIST_TYPE]: merge({}, defaultSettings, loadFromLocalStorage(LIST_TYPES.DELIVERY_NOTE_LIST_TYPE), { filterItems: deliveryNoteConfig.filters }),
  [LIST_TYPES.LETTER_LIST_TYPE]: merge({}, defaultSettings, loadFromLocalStorage(LIST_TYPES.LETTER_LIST_TYPE), { filterItems: letterConfig.filters }),
  [LIST_TYPES.PROJECT_LIST_TYPE]: merge({}, defaultSettings, loadFromLocalStorage(LIST_TYPES.PROJECT_LIST_TYPE), { filterItems: projectConfig.filters }),
  [LIST_TYPES.ORDER_LIST_TYPE]: merge({}, defaultSettings, loadFromLocalStorage(LIST_TYPES.ORDER_LIST_TYPE), { filterItems: orderConfig.filters }),
  [LIST_TYPES.PURCHASE_LIST_TYPE]: merge({}, defaultSettings, loadFromLocalStorage(LIST_TYPES.PURCHASE_LIST_TYPE), { filterItems: purchaseConfig.filters }),
  [LIST_TYPES.PURCHASE_PARTIAL_DELIVERY_DRAWER_LIST_TYPE]: merge(
    {},
    defaultSettings,
    loadFromLocalStorage(LIST_TYPES.PURCHASE_PARTIAL_DELIVERY_DRAWER_LIST_TYPE),
    {
      filterItems: [],
      setting: {
        columns: getPurchasePartialDeliveryDrawerColumns(),
        autoSizeColumns: true,
      },
    },
  ),
  [LIST_TYPES.TIME_TRACKING_LIST_TYPE]: merge(
    {},
    defaultSettings,
    loadFromLocalStorage(LIST_TYPES.TIME_TRACKING_LIST_TYPE),
    { filterItems: timeTrackingConfig.filters },
  ),
  [LIST_TYPES.RECURRING_INVOICE_LIST_TYPE]: merge({}, defaultSettings, loadFromLocalStorage(LIST_TYPES.RECURRING_INVOICE_LIST_TYPE), { filterItems: recurringinvoiceConfig.filters }),
  [LIST_TYPES.CUSTOMER_LIST_TYPE]: merge({}, defaultSettings, loadFromLocalStorage(LIST_TYPES.CUSTOMER_LIST_TYPE), { filterItems: customerConfig.filters }),
  [LIST_TYPES.ARTICLE_LIST_TYPE]: merge({}, defaultSettings, loadFromLocalStorage(LIST_TYPES.ARTICLE_LIST_TYPE), { filterItems: articleConfig.filters }),
  [LIST_TYPES.ARTICLE_REPORT_LIST_TYPE]: merge({}, defaultSettings, loadFromLocalStorage(LIST_TYPES.ARTICLE_REPORT_LIST_TYPE), { filterItems: articleConfig.filters }),
  [LIST_TYPES.BOOKING_SELECTION_LIST_TYPE]: merge(
    {},
    defaultSettings,
    loadFromLocalStorage(LIST_TYPES.BOOKING_SELECTION_LIST_TYPE),
    { filterItems: [], setting: { columns: bookingSelectionConfig.getColumns(LIST_TYPES.BOOKING_SELECTION_LIST_TYPE), autoSizeColumns: true } },
  ),
  [LIST_TYPES.REVENUE_SELECTION_LIST_TYPE]: merge(
    {},
    defaultSettings,
    loadFromLocalStorage(LIST_TYPES.REVENUE_SELECTION_LIST_TYPE),
    { filterItems: [], setting: { columns: bookingSelectionConfig.getColumns(LIST_TYPES.REVENUE_SELECTION_LIST_TYPE), autoSizeColumns: true } },
  ),
  [LIST_TYPES.INTERNAL_BANK_TRANSFER_SELECTION_LIST_TYPE]: merge(
    {},
    defaultSettings,
    loadFromLocalStorage(LIST_TYPES.INTERNAL_BANK_TRANSFER_SELECTION_LIST_TYPE),
    { setting: { columns: internalTransferColumns, autoSizeColumns: true } },
  ),
  [LIST_TYPES.OFFER_LIST_TYPE]: merge({}, defaultSettings, loadFromLocalStorage(LIST_TYPES.OFFER_LIST_TYPE), { filterItems: offerConfig.filters }),
  [LIST_TYPES.SUPPLIER_LIST_TYPE]: merge({}, defaultSettings, loadFromLocalStorage(LIST_TYPES.SUPPLIER_LIST_TYPE)),
  [LIST_TYPES.TIME_TRACKING_BILLING_LIST_TYPE]: merge(
    {},
    defaultSettings,
    loadFromLocalStorage(LIST_TYPES.TIME_TRACKING_BILLING_LIST_TYPE),
    { filterItems: [], setting: { columns: timeTrackingBillingConfig.columns, autoSizeColumns: true } },
  ),
  [LIST_TYPES.BOOKING_ASSIGNMENT_LIST_TYPE]: merge(
    {},
    defaultSettings,
    loadFromLocalStorage(LIST_TYPES.BOOKING_ASSIGNMENT_LIST_TYPE),
    { filterItems: [] },
  ),
  [LIST_TYPES.USER_LIST_TYPE]: merge(
    {},
    defaultSettings,
    loadFromLocalStorage(LIST_TYPES.USER_LIST_TYPE),
  ),
  [LIST_TYPES.TODO_LIST_TYPE]: merge(
    {},
    defaultSettings,
    loadFromLocalStorage(LIST_TYPES.TODO_LIST_TYPE),
    { filterItems: [] },
  ),
  [LIST_TYPES.CUSTOM_FIELD_LIST_TYPE]: merge(
    {},
    defaultSettings,
    loadFromLocalStorage(LIST_TYPES.CUSTOM_FIELD_LIST_TYPE),
    { filterItems: [] },
  ),
  [LIST_TYPES.CLIENT_LIST_TYPE]: merge(
    {},
    defaultSettings,
    loadFromLocalStorage(LIST_TYPES.CLIENT_LIST_TYPE),
    { filterItems: clientListConfig.filters },
  ),
  [LIST_TYPES.DOCUMENTS_LIST_TYPE]: merge({}, defaultSettings, loadFromLocalStorage(LIST_TYPES.DOCUMENTS_LIST_TYPE), { filterItems: documentConfig.filters }),
  [LIST_TYPES.ECONOMIC_ASSET_LIST_TYPE]: merge({}, defaultSettings, loadFromLocalStorage(LIST_TYPES.ECONOMIC_ASSET_LIST_TYPE), { filterItems: economicAssetConfig.filters }),
  [LIST_TYPES.MANDATE_LIST_TYPE]: merge({}, defaultSettings, loadFromLocalStorage(LIST_TYPES.MANDATE_LIST_TYPE)),
  [LIST_TYPES.DEBIT_TRANSACTION_PLANNED_LIST_TYPE]: merge({},
    defaultSettings, loadFromLocalStorage(LIST_TYPES.DEBIT_TRANSACTION_PLANNED_LIST_TYPE),
    { filterItems: debitTransactionConfig.filters[LIST_TYPES.DEBIT_TRANSACTION_PLANNED_LIST_TYPE] }),
  [LIST_TYPES.DEBIT_TRANSACTION_SETTLED_LIST_TYPE]: merge({},
    defaultSettings, loadFromLocalStorage(LIST_TYPES.DEBIT_TRANSACTION_SETTLED_LIST_TYPE),
    { filterItems: debitTransactionConfig.filters[LIST_TYPES.DEBIT_TRANSACTION_SETTLED_LIST_TYPE] }),
  [LIST_TYPES.IMPORT_POSITIONS_TRANSACTION_PICKER_TYPE]: merge({}, defaultSettings),
  [LIST_TYPES.IMPORT_POSITIONS_POSITION_PREVIEW_TYPE]: merge({}, defaultSettings),
  [LIST_TYPES.ADD_MULTIPLE_ARTICLES_LIST_TYPE]: merge(
    {},
    defaultSettings,
    {
      filterItems: [],
      setting: {
        columns: [],
        autoSizeColumns: false,
      },
    }
  ),
  [LIST_TYPES.ARTICLE_SUPPLIERS_ASSIGN_DRAWER_TYPE]: merge(
    {},
    defaultSettings,
    loadFromLocalStorage(LIST_TYPES.ARTICLE_SUPPLIERS_ASSIGN_DRAWER_TYPE),
    {
      filterItems: [],
      setting: {
        columns: articleSuppliersAssignDrawerConfig.getColumns(),
        autoSizeColumns: true,
      },
    },
  ),
  // "Meine Meldungen" (FLAG:docuAiEnhancements) — clientseitige Liste aus dem customerIssues-Slice,
  // ohne Server-Setting: Spalten und Statusfilter kommen aus der Modul-Konfiguration.
  [LIST_TYPES.CUSTOMER_ISSUES_LIST_TYPE]: merge(
    {},
    defaultSettings,
    loadFromLocalStorage(LIST_TYPES.CUSTOMER_ISSUES_LIST_TYPE),
    {
      filterItems: customerIssuesListConfig.filters,
      setting: {
        columns: customerIssuesListConfig.getColumns(),
        autoSizeColumns: true,
      },
    },
  ),
}
const setStateProperty = (state, list, values) => {
  const newState = { ...state }
  newState[list] = { ...newState[list], ...values }
  return newState
}

const stripAssignmentStateFromFilterModel = (model) => {
  if (!model?.state) {
    return model
  }
  const { state: assignmentStateFilter, ...rest } = model
  return Object.keys(rest).length ? rest : null
}

const recountFilterItems = (items, filterItems, filterModel, quickFilter, dateFilters = []) => {
  if (!filterItems.length) {
    return filterItems
  }

  const dateFilteredItems = applyDateFiltersToItems(items, dateFilters)
  return countQuickFilter(dateFilteredItems, filterItems)
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case PAGINATION_UPDATE: {
      const { list, pagination } = action
      const previousPagination = state[list].pagination
      const newState = setStateProperty(state, list, { pagination: { ...previousPagination, ...omitBy(pagination, isNil) } })
      saveToLocalStorage(list, newState)
      return newState
    }
    case SHALL_EXPORT: {
      const { list, shallExport, exportItems, exportParams } = action
      const newState = setStateProperty(state, list, { shallExport, exportItems, exportParams })
      return newState
    }
    case SHALL_REFRESH: {
      const { list, shallRefresh } = action
      const { pagination } = state[list]
      const newState = shallRefresh
        ? setStateProperty(state, list, {
          shallRefresh,
          fetchCounters: true,
          meta: {
            count: 0, // count of filtered items
            totalCount: 0, // count of all items
          },
          pagination: {
            offset: 0, // current starting point in list
            count: 0, // count of filtered items
            limit: pagination.limit,
          },
          selectedNodes: [],
          exportItems: [],
        })
        : setStateProperty(state, list, { shallRefresh })
      return newState
    }
    case SHALL_SOFT_REFRESH: {
      // FLAG:useDocuAi — refetch the server rows without tearing the list down: no meta/pagination
      // reset and no selection loss, so a background refetch stays invisible. Counters may still be
      // re-fetched — that does not blank the current ones. Additive and inert flag-OFF: only
      // useDocuAi-gated callsites dispatch it (expenseList.softRefreshList), every legacy caller
      // keeps using SHALL_REFRESH above, which is unchanged.
      const { list, shallSoftRefresh } = action
      return shallSoftRefresh
        ? setStateProperty(state, list, { shallSoftRefresh, fetchCounters: true })
        : setStateProperty(state, list, { shallSoftRefresh })
    }
    case SEARCH_UPDATE: {
      const { list, searchTerm } = action
      return setStateProperty(state, list, {
        searchTerm,
        fetchCounters: true,
        meta: {},
        pagination: { ...state[list]?.pagination, offset: 0 },
      })
    }
    case QUICK_FILTER_INIT: {
      const { list, filterData } = action
      const newState = setStateProperty(state, list, {
        filterItems: getFilterItems[list](filterData),
        fetchCounters: false,
      })
      return newState
    }
    case QUICK_FILTER_UPDATE: {
      const { list, filter } = action
      const currentFilter = state[list].filterItems.find(item => item.name === filter)
      const {
        dateFilters,
        quickFilter: previousQuickFilter,
        filterModel: previousFilterModel,
      } = state[list]
      const hasPersistentDateFilters = [LIST_TYPES.BANKING_LIST_TYPE, LIST_TYPES.BOOKING_LIST_TYPE].includes(list)
      const isAllFilter = !filter || filter === 'all'
      const previousQuickFilterKeys = Object.keys(previousQuickFilter || {})
      const keysToRemoveFromFilterModel = [
        ...previousQuickFilterKeys.filter(key => key !== DATE_FILTER_MODEL_KEY),
        ...(isAllFilter && hasPersistentDateFilters ? ['state'] : []),
      ]
      const cleanedFilterModel = keysToRemoveFromFilterModel.length
        ? Object.keys(previousFilterModel || {}).reduce((result, key) => {
          if (!keysToRemoveFromFilterModel.includes(key)) {
            result[key] = previousFilterModel[key]
          }
          return result
        }, {})
        : previousFilterModel

      let nextFilterModel = cleanedFilterModel && Object.keys(cleanedFilterModel).length ? cleanedFilterModel : null
      if (hasPersistentDateFilters) {
        nextFilterModel = stripAssignmentStateFromFilterModel(nextFilterModel)
        if (dateFilters.length) {
          nextFilterModel = getDateFilterModel({ dateFilters, filterModel: nextFilterModel })
        }
      }

      const newQuickFilter = isAllFilter ? null : currentFilter?.quickFilter
      const newFilterItems = hasPersistentDateFilters
        ? recountFilterItems(state[list].items, state[list].filterItems, nextFilterModel, newQuickFilter, dateFilters)
        : state[list].filterItems

      const newState = setStateProperty(state, list, {
        dateFilters: hasPersistentDateFilters || PERIOD_FILTER_LISTS.includes(list) ? dateFilters : [],
        filterModel: nextFilterModel,
        quickFilter: newQuickFilter,
        filter: filter || 'all',
        filterItems: newFilterItems,
        pagination: { ...state[list].pagination, index: 0 },
      })
      saveToLocalStorage(list, newState)
      return newState
    }
    case DATE_FILTERS_CLEAR: {
      const { list } = action
      if (PERIOD_FILTER_LISTS.includes(list)) {
        const newState = setStateProperty(state, list, {
          dateFilters: [],
          dateFilterItems: getDateFilterItems(undefined),
          pagination: { ...state[list].pagination, index: 0 },
        })
        saveToLocalStorage(list, newState)
        return newState
      }
      const { items, filterItems, quickFilter } = state[list]
      const newFilterItems = recountFilterItems(items, filterItems, null, quickFilter, [])

      const newState = setStateProperty(state, list, {
        filter: 'all',
        quickFilter: null,
        filterModel: null,
        dateFilters: [],
        dateFilterItems: getDateFilterItems(undefined),
        filterItems: newFilterItems,
        pagination: { ...state[list].pagination, index: 0 },
      })
      saveToLocalStorage(list, newState)
      return newState
    }
    case DATE_FILTERS_UPDATE: {
      const { list, filter, filterType } = action

      const { dateFilters, filterModel, updatedFilterItems } = handleDateFilters({ state, list, filterType, filter })
      if (PERIOD_FILTER_LISTS.includes(list)) {
        const newState = setStateProperty(state, list, {
          dateFilters,
          dateFilterItems: updatedFilterItems,
          pagination: { ...state[list].pagination, index: 0 },
        })
        saveToLocalStorage(list, newState)
        return newState
      }
      const { items, filterItems, quickFilter } = state[list]
      const newFilterItems = recountFilterItems(items, filterItems, filterModel, quickFilter, dateFilters)

      const newState = setStateProperty(state, list, {
        filterModel,
        dateFilters,
        dateFilterItems: updatedFilterItems,
        filterItems: newFilterItems,
        pagination: { ...state[list].pagination, index: 0 },
      })
      saveToLocalStorage(list, newState)
      return newState
    }
    case FILTER_MODEL_UPDATE: {
      const { list, filterModel } = action
      const newState = setStateProperty(state, list, { filterModel, fetchCounters: true, meta: {} })
      saveToLocalStorage(list, newState)
      return newState
    }
    case FILTER_ITEMS_UPDATE: {
      const { list, filterItems } = action
      const newState = setStateProperty(state, list, { filterItems })
      saveToLocalStorage(list, newState)
      return newState
    }
    case SELECTED_NODES_UPDATE: {
      const { list, selectedNodes } = action
      return setStateProperty(state, list, { selectedNodes })
    }
    case UPDATE_DATA: {
      const { list, data } = action
      return setStateProperty(state, list, {
        ...data,
        error: null,
        isLoading: false,
      })
    }
    case QUICK_COUNTER_UPDATE: {
      const { list, meta } = action
      const { filterItems, meta: prevMeta } = state[list]
      const newFilterItems = uniqBy(filterItems.map(item => {
        if (!isNil(meta[item.name])) {
          return { ...item, count: meta[item.name] }
        }
        return item
      }), 'name')
      return setStateProperty(state, list, {
        filterItems: newFilterItems,
        meta: { ...prevMeta, ...omitBy(meta, isNil) },
        fetchCounters: false,
      })
    }
    case UPDATE_ITEMS: {
      const { list, items, meta } = action
      let newFilter = state[list].filter
      let isFirstUpdate = state[list].isFirstUpdate

      const currentFilterForCount = state[list].filterItems.find(item => item.name === newFilter)
      const filterModel = state[list].filterModel
      const isAllFilter = !newFilter || newFilter === 'all'
      const hasPersistentDateFilters = [LIST_TYPES.BANKING_LIST_TYPE, LIST_TYPES.BOOKING_LIST_TYPE].includes(list)
      const newQuickFilter = isAllFilter ? null : currentFilterForCount?.quickFilter
      let newFilterModel = hasPersistentDateFilters
        ? stripAssignmentStateFromFilterModel(filterModel)
        : filterModel

      if (hasPersistentDateFilters && state[list].dateFilters.length) {
        newFilterModel = getDateFilterModel({
          dateFilters: state[list].dateFilters,
          filterModel: newFilterModel,
        })
      }
      const newFilterItems = state[list].filterItems.length
        ? recountFilterItems(items, state[list].filterItems, newFilterModel, newQuickFilter, state[list].dateFilters)
        : []

      // check if filter items have a priority > set active filter depending on it
      if (newFilterItems.length && Object.prototype.hasOwnProperty.call(newFilterItems[0], 'priority') && state[list].isFirstUpdate) {
        let currentPriority = newFilterItems[0].priority
        newFilterItems.forEach((item) => {
          if (item.count && item.priority < currentPriority) {
            newFilter = item.name
            currentPriority = item.priority
          }
        })
      }

      const currentFilter = state[list].filterItems.find(item => item.name === newFilter)
      const resolvedQuickFilter = !newFilter || newFilter === 'all' ? null : currentFilter?.quickFilter

      if (isFirstUpdate) {
        isFirstUpdate = false
      }

      return setStateProperty(state, list, {
        items,
        filter: newFilter,
        quickFilter: resolvedQuickFilter,
        filterModel: newFilterModel,
        filterItems: newFilterItems,
        selectedNodes: [],
        error: null,
        isLoading: false,
        isFirstUpdate,
        meta,
      })
    }
    case LIST_LOADING: {
      const { list, isLoading } = action
      return setStateProperty(state, list, { isLoading })
    }
    case LIST_SYNCING: {
      const { list, isSyncing } = action
      return setStateProperty(state, list, { isSyncing })
    }
    case LIST_CLEAR: {
      const { list } = action
      return setStateProperty(state, list, initialState[list])
    }
    case LIST_ERROR: {
      const { list, error } = action
      return setStateProperty(state, list, { items: [], error, isLoading: false })
    }
    case SETTING_UPDATE: {
      const { list, setting } = action
      return setStateProperty(state, list, { settingError: null, setting, isSettingLoading: false })
    }
    case SETTING_ERROR: {
      const { list, settingError } = action
      return setStateProperty(state, list, { settingError, isSettingLoading: false })
    }
    case SETTING_LOADING: {
      const { list } = action
      return setStateProperty(state, list, { settingError: null, isSettingLoading: true })
    }
    case SETTING_LOADING_FINISHED: {
      const { list } = action
      return setStateProperty(state, list, { settingError: null, isSettingLoading: false })
    }
    case SETTING_MODAL_TOGGLE: {
      const { list, show } = action
      return setStateProperty(state, list, { settingModalOpen: show })
    }
    case ADD_ITEM: {
      const { list, item } = action
      return setStateProperty(state, list, { items: [...state[list].items, item] })
    }
    case START_PRINTING: {
      const { list, modelType, dataToPrint } = action
      const data = dataToPrint ? [{ data: dataToPrint }] : state[list].selectedNodes
      printSelection(list, modelType, data)
      return setStateProperty(state, list, { printing: true })
    }
    case STOP_PRINTING: {
      const { list } = action
      return setStateProperty(state, list, { printing: false })
    }
    case DELETE_ITEM: {
      const { list, idToRemove } = action
      const newItemsClean = state[list].items.filter(item => idToRemove !== item.id)
      return setStateProperty(state, list, { items: newItemsClean })
    }
    case UPDATE_CUSTOM_PARAMS: {
      const { list, customParams } = action
      return setStateProperty(state, list, { customParams })
    }
    case UPDATE_LAST_SELECTED_ROW_INDEX: {
      const { list, rowIndex } = action
      return setStateProperty(state, list, { lastSelectedRowIndex: rowIndex })
    }
    case UPDATE_LAST_EXPANDED_ROW_KEY: {
      const { list, expandedRowKey } = action
      return setStateProperty(state, list, { lastExpandedRowKey: expandedRowKey })
    }
    case UPDATE_AUTO_SIZE_COLUMNS: {
      const { list, autoSizeColumns } = action
      return setStateProperty(state, list, { autoSizeColumns })
    }
    default:
      return state
  }
}

export const updateLastSelectedRowIndex = (list, rowIndex) => {
  return { type: UPDATE_LAST_SELECTED_ROW_INDEX, list, rowIndex }
}

export const updateLastExpandedRowKey = (list, expandedRowKey) => {
  return { type: UPDATE_LAST_EXPANDED_ROW_KEY, list, expandedRowKey }
}

export const updatePagination = (list, pagination) => {
  return { type: PAGINATION_UPDATE, list, pagination }
}

export const setShallExport = (list, shallExport, exportItems = [], exportParams = null) => {
  return {
    type: SHALL_EXPORT,
    list,
    shallExport,
    exportItems,
    exportParams,
  }
}

export const setShallRefresh = (list, shallRefresh = true) => {
  return {
    type: SHALL_REFRESH,
    list,
    shallRefresh,
  }
}

// FLAG:useDocuAi — non-destructive counterpart of setShallRefresh: triggers a server refetch that
// keeps meta, pagination and the current selection intact (see list-v2). Only dispatched from
// useDocuAi-gated callsites; flag-OFF nothing reaches it.
export const setShallSoftRefresh = (list, shallSoftRefresh = true) => {
  return {
    type: SHALL_SOFT_REFRESH,
    list,
    shallSoftRefresh,
  }
}

export const updateSearchTerm = (list, searchTerm) => {
  return {
    type: SEARCH_UPDATE,
    list,
    searchTerm,
  }
}

export const initQuickFilter = (list, filterData) => {
  return {
    type: QUICK_FILTER_INIT,
    list,
    filterData,
  }
}

export const updateQuickFilter = (list, filter) => {
  return {
    type: QUICK_FILTER_UPDATE,
    list,
    filter,
  }
}

export const updateDateFilters = (list, filter, type) => {
  return {
    type: DATE_FILTERS_UPDATE,
    list,
    filter,
    filterType: type,
  }
}

export const clearDateFilters = (list) => {
  return {
    type: DATE_FILTERS_CLEAR,
    list,
  }
}

export const updateFilterModel = (list, filterModel) => {
  return {
    type: FILTER_MODEL_UPDATE,
    list,
    filterModel,
  }
}

export const updateFilterItems = (list, filterItems) => {
  return {
    type: FILTER_ITEMS_UPDATE,
    list,
    filterItems,
  }
}

export const updateSelectedNodes = (list, selectedNodes) => {
  return {
    type: SELECTED_NODES_UPDATE,
    list,
    selectedNodes,
  }
}

export const updateItems = (list, items, meta) => {
  return {
    type: UPDATE_ITEMS,
    list,
    items,
    meta,
  }
}

export const updateQuickCounter = (list, meta) => {
  return {
    type: QUICK_COUNTER_UPDATE,
    list,
    meta,
  }
}

export const updateData = (list, data) => {
  return {
    type: UPDATE_DATA,
    list,
    data,
  }
}

export const listLoading = (list, isLoading = true) => {
  return {
    type: LIST_LOADING,
    list,
    isLoading,
  }
}

export const setListSyncing = (list, isSyncing = true) => {
  return {
    type: LIST_SYNCING,
    list,
    isSyncing,
  }
}

export const listError = (list, error) => {
  return {
    type: LIST_ERROR,
    list,
    error,
  }
}

export const clearList = (list, target, force) => {
  return {
    type: LIST_CLEAR,
    list,
  }
}

export const settingsLoading = (list) => {
  return {
    type: SETTING_LOADING,
    list,
  }
}

export const settingsLoadingFinished = (list) => {
  return {
    type: SETTING_LOADING_FINISHED,
    list,
  }
}

export const settingsUpdate = (list, setting) => {
  return {
    type: SETTING_UPDATE,
    list,
    setting,
  }
}

export const settingsError = (list, settingError) => {
  return {
    type: SETTING_ERROR,
    list,
    settingError,
  }
}

export const toggleSettingModal = (list, show) => {
  return {
    type: SETTING_MODAL_TOGGLE,
    list,
    show,
  }
}

export const addItem = (list, item) => ({
  type: ADD_ITEM,
  list,
  item,
})

export const startPrinting = (list, modelType, dataToPrint = null) => ({
  type: START_PRINTING,
  list,
  modelType,
  dataToPrint,
})

export const stopPrinting = (list) => ({
  type: STOP_PRINTING,
  list,
})

export const deleteItem = (list, idToRemove, meta) => {
  return {
    type: DELETE_ITEM,
    list,
    idToRemove,
    meta,
  }
}

export const updateCustomParams = (list, customParams) => {
  return {
    type: UPDATE_CUSTOM_PARAMS,
    list,
    customParams,
  }
}

export const updateAutoSizeColumns = (list, autoSizeColumns) => {
  return {
    type: UPDATE_AUTO_SIZE_COLUMNS,
    list,
    autoSizeColumns,
  }
}

export const getList = (list) => {
  const store = require('@/redux/store').default
  const data = store.getState().lists[list]
  return data
}

export const dispatch = (data) => {
  const store = require('@/redux/store').default
  return store.dispatch(data)
}

export const QUERY_TYPES = {
  DATA: 'data',
  COUNTER: 'counter',
  ALL: 'all',
}

export const fetchCounter = (list, url, dataToSend) => {
  return request(url, {
    method: 'POST',
    auth: true,
    isConcurrent: true,
    timeout: globalConfig.requestExtraLongTimeout,
    data: { ...dataToSend, queryType: QUERY_TYPES.COUNTER },
  })
    .then(response => {
      const { meta } = response.body
      dispatch(updateQuickCounter(list, meta))
    })
    .catch((error) => {
      dispatch(listError(list, error))
    })
}

export const refreshFilterItems = (list) => {
  return (dispatch, getState) => {
    const { items, filterItems, filterModel, quickFilter, dateFilters } = getState().lists[list]
    const newFilterItems = recountFilterItems(items, filterItems, filterModel, quickFilter, dateFilters)
    dispatch(updateFilterItems(list, newFilterItems))
    dispatch(setShallRefresh(list, true))
  }
}

// Called when user is logged out or switches tenant
export const resetFiltersForAllLists = () => {
  return (dispatch) => {
    for (const listName of Object.values(LIST_TYPES)) {
      dispatch(updateFilterModel(listName, null))
      if (listName === LIST_TYPES.BANKING_LIST_TYPE) {
        dispatch(clearDateFilters(listName))
      }
      dispatch(updateQuickFilter(listName, null))
      dispatch(clearDateFilters(listName))
      dispatch(updateSearchTerm(listName, ''))
    }
  }
}

export const saveColumnWidthInUserListSetting = async(listName, columns) => {
  const requestData = columns
    .reduce((columns, column) => {
      if (column.colId !== 'menu' && column.colDef.label && column.colDef.name) {
        columns.push(pick({ ...column.colDef, width: column.actualWidth }, ['active', 'label', 'name', 'required', 'width']))
      }
      return columns
    }, [])

  return request(`${globalConfig.resourceHost}setting/userlist/${getListSettingNameInBackend(listName)}/columns`, {
    auth: true,
    method: 'PUT',
    data: requestData,
  })
}
